"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var meta_group_id_1 = require("./meta-group-id");
var MetaGroup = /** @class */ (function () {
    function MetaGroup(systemName, displayName, metaFields, displayNameMultilingual) {
        this.systemName = systemName;
        this.displayName = displayName;
        this.metaFields = metaFields;
        this.displayNameMultilingual = displayNameMultilingual;
    }
    MetaGroup.prototype.getMetaGroupId = function () {
        return new meta_group_id_1.MetaGroupId(this.systemName);
    };
    MetaGroup.prototype.getDisplayName = function () {
        return this.displayName;
    };
    MetaGroup.prototype.getSystemName = function () {
        return this.systemName;
    };
    MetaGroup.prototype.getMetaFields = function () {
        return this.metaFields;
    };
    MetaGroup.prototype.getDisplayNameMultilingual = function () {
        return this.displayNameMultilingual;
    };
    return MetaGroup;
}());
exports.MetaGroup = MetaGroup;
//# sourceMappingURL=meta-group.js.map